import { Col } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import HeadingBack from "../component/HeadingBack";
import { allapiAction } from "../../Redux/common/action";
import { URL } from "../../Redux/common/url";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import Api from "../../Redux/common/api";
import Select from "react-select";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";

import ImageUploading from "react-images-uploading";
import { DeleteOutlined } from "@ant-design/icons";

function UpdateProduct() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const [rows, setRows] = useState([]);
  const [aboutPage, setaboutPage] = useState("");
  const [images, setImages] = useState([]);
  const [productData, setproductData] = useState({});

  // Dropdown States
  const [selectedOption, setSelectedOption] = useState(null); // Sub Sub Category
  const [subList, setsubList] = useState([]);

  const [selectedOptionPr, setSelectedOptionPr] = useState(null); // Main Category
  const [maincateList, setmaincateList] = useState([]);

  const [selectedOption4, setSelectedOption4] = useState(null); // Sub Category
  const [subList4, setsubList4] = useState([]);

  const [selectedOptionbrand, setSelectedOptionbrand] = useState(null); // Brand
  const [branList, setbrandList] = useState([]);

  // Redux Selectors
  const get_sub_sub_category_list = useSelector((state) =>
    state.allapi.get_sub_sub_category_list
      ? state.allapi.get_sub_sub_category_list
      : [],
  );
  const get_main_all_category = useSelector((state) =>
    state?.allapi?.get_main_all_category
      ? state?.allapi?.get_main_all_category
      : [],
  );
  const get_sub_sub_category = useSelector((state) =>
    state?.allapi?.get_sub_sub_all_category
      ? state?.allapi?.get_sub_sub_all_category
      : [],
  );
  const grt_all_brand = useSelector((state) =>
    state.allapi.grt_all_brand ? state.allapi.grt_all_brand : [],
  );
  const get_product_details = useSelector((state) =>
    state.allapi.get_product_details ? state.allapi.get_product_details : {},
  );

  useEffect(() => {
    if (get_product_details?.subcolor?.length > 0) {
      const selectCate = subList.find(
        (edata) => edata?._id == get_product_details?.categoryId,
      );

      if (get_product_details?.description !== undefined) {
        setaboutPage(get_product_details?.description);
      }

      setSelectedOption(selectCate);
      setproductData(get_product_details);

      setImages([
        { data_url: URL.API_BASE_URL + get_product_details.featureImage },
      ]);
      const finalData = get_product_details?.subcolor?.map((data) => {
        const dataImg = data?.images?.map((data2) => {
          const finalimg = { data_url: URL.API_BASE_URL + data2.img };
          return finalimg;
        });
        data.images = dataImg;
        return data;
      });

      setRows(finalData);
    }
  }, [get_product_details, subList]);

  // Main Category Dropdown Options
  useEffect(() => {
    const dropList = get_main_all_category?.map((data) => {
      data.value = data?._id;
      data.label = data?.name;
      return data;
    });
    setmaincateList(dropList);
  }, [get_main_all_category]);

  // Pre-fill Main and Sub Category logic
  useEffect(() => {
    if (maincateList?.length > 0 && get_product_details?.categoryDetails) {
      const getfind = maincateList.find(
        (edata) =>
          edata?._id == get_product_details?.categoryDetails[0]?.parentId,
      );

      if (getfind !== undefined) {
        setSelectedOptionPr(getfind);

        const filterdata = get_sub_sub_category?.filter((data) => {
          return data?.parentId == getfind?._id;
        });

        const dropList = filterdata?.map((data) => {
          data.value = data?._id;
          data.label = data?.name;
          return data;
        });

        const getfindv = dropList.find(
          (edata) =>
            edata?._id == get_product_details?.categoryDetails[0]?.subparentId,
        );

        setsubList4(dropList);
        setSelectedOption4(getfindv);
      }
    }
  }, [maincateList, get_product_details, get_sub_sub_category]);

  // Brand Options & Pre-fill
  useEffect(() => {
    const dropList = grt_all_brand?.map((data) => {
      data.value = data?._id;
      data.label = data?.name;
      return data;
    });
    setbrandList(dropList);
  }, [grt_all_brand]);

  useEffect(() => {
    if (branList?.length > 0 && get_product_details?.categoryDetails) {
      const getfind = branList.find(
        (edata) => edata?._id == get_product_details?.brandId,
      );
      if (getfind !== undefined) {
        setSelectedOptionbrand(getfind);
      }
    }
  }, [branList, get_product_details]);

  const hendletotest = (e) => {
    setSelectedOptionPr(e);
    const filterdata = get_sub_sub_category?.filter((data) => {
      return data?.parentId == e?._id;
    });

    const dropList = filterdata?.map((data) => {
      data.value = data?._id;
      data.label = data?.name;
      return data;
    });

    setsubList4(dropList);
    setSelectedOption4(null);
    setSelectedOption(null);
  };

  const onChange = (imageList, addUpdateIndex) => {
    setImages(imageList);
  };

  useEffect(() => {
    dispatch(allapiAction.getsubsubcate({}));
    // dispatch(allapiAction.getbrandAllListseller({}));
    dispatch(allapiAction.productDetails(id));
    dispatch(allapiAction.getsubcateAllList({}));
    dispatch(allapiAction.getcateAllList({}));
    return () => {};
  }, [dispatch, id]);

  useEffect(() => {
    const dropList = get_sub_sub_category_list?.map((data) => {
      data.value = data?._id;
      data.label = data?.name;
      return data;
    });
    setsubList(dropList);
  }, [get_sub_sub_category_list]);

  const maxNumber = 8; // Kept at 8 as per original admin setup

  const HendleImgFVer = (e, pictureDataURLs, index) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      if (!Array.isArray(updatedRows[index].images)) {
        updatedRows[index].images = [];
      }
      updatedRows[index].images.push(e[e.length - 1]);
      return updatedRows;
    });
  };

  const onRemoveImage = (variantIndex, imageIndex) => {
    setRows((prevVariants) => {
      const updatedVariants = [...prevVariants];
      updatedVariants[variantIndex].images.splice(imageIndex, 1);
      return updatedVariants;
    });
  };

  const addSizeProduct = (index) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows[index].productsize.push({
        size: "",
        sizetype: "",
        price: "",
        stock: "",
        afterdiscountprice: "",
      });
      return updatedRows;
    });
  };

  const removeSizeProduct = (rowIndex, sizeIndex) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows[rowIndex].productsize.splice(sizeIndex, 1);
      return updatedRows;
    });
  };

  const removeColorProduct = (index) => {
    setRows((prevRows) => prevRows.filter((row, i) => i !== index));
  };

  const handleSizeChange = (rowIndex, sizeIndex, field, value) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows[rowIndex].productsize[sizeIndex][field] = value;
      return updatedRows;
    });
  };

  const handleColorChange = (rowIndex, sizeIndex, field, value) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows[rowIndex][field] = value;
      return updatedRows;
    });
  };

  const API_URl = URL.API_BASE_URL;
  const UPLOAD_ENDPOINT = "publicApi/productcon";

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          const body = new FormData();
          loader.file.then((file) => {
            body.append("upload", file);
            fetch(`${API_URl}/${UPLOAD_ENDPOINT}`, {
              method: "post",
              body: body,
            })
              .then((res) => res.json())
              .then((res) => resolve({ default: `${res.url}` }))
              .catch((err) => reject(err));
          });
        });
      },
    };
  }

  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }

  const hendleChangerole = (e) => {
    const { name, value } = e.target;
    setproductData({ ...productData, [name]: value });
  };

  const hendleTosubmit = async () => {
    const data = new FormData();

    if (images?.length == 0) {
      toast.error("please select feature Image");
    } else if (!productData?.title) {
      toast.error("please enter product name");
    } else if (!selectedOption) {
      toast.error("please select category ");
    } else {
      data.append("productId", productData?._id);
      data.append("title", productData?.title);
      data.append("price", productData?.price);
      data.append("seo_title", productData?.seo_title);
      data.append("sku", productData?.sku);
      data.append("bv", productData?.bv);
      data.append("bouns", productData?.bouns);
      data.append("seo_description", productData?.seo_description);
      data.append("categoryId", selectedOption?._id);
      data.append("category1Id", selectedOptionPr?._id);
      data.append("brandId", selectedOptionbrand?._id);
      data.append("category2Id", selectedOption4?._id);
      data.append("gst", productData?.gst);
      data.append("delivery_charges", productData?.delivery_charges);
      data.append("afterdiscountprice", productData?.afterdiscountprice);
      data.append("description", aboutPage);

      if (images[0]?.file) {
        data.append("featureImage", images[0]?.file);
      }

      // Keep admin authentication token
      const token = await localStorage.getItem("admin_token");

      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      await Api.post(`${URL.updateProduct}`, data, config);

      for (const row of rows) {
        const data2 = new FormData();
        data2.append("productId", productData?._id);
        data2.append("color", row?.color);
        if (row?._id) {
          data2.append("_id", row?._id);
        }
        data2.append("gst", productData?.gst);
        data2.append("delivery_charges", productData?.delivery_charges);

        const psize = row?.productsize?.map((data) => {
          data.productcolorId = data.productcolorId
            ? data.productcolorId
            : row?._id;
          return data;
        });
        data2.append("sizeProduct", JSON.stringify(psize));

        row?.images?.forEach((file) => {
          if (file?.file) {
            data2.append("images", file?.file);
          } else {
            const relativeUrl = file?.data_url.replace(URL.API_BASE_URL, "");
            data2.append("oldimages", relativeUrl);
          }
        });

        await Api.post(`${URL.updateProductvariations}`, data2, config);
      }

      // Navigate to admin route
      navigate("/product");
    }
  };

  return (
    <div className="code-box">
      <div className="flex">
        <div>
          <HeadingBack title={"Product"} />
        </div>
        <Col md={5} sm={5} xs={12} className="pl-5 ml-5"></Col>
      </div>

      <div>
        <div className="container pdcon">
          <div className="row">
            <div className="col-12">
              <div className="fv-row mb-7">
                <label className="fs-6 fw-semibold form-label mb-2">
                  <span className="required">Feature Image</span>
                </label>
                <ImageUploading
                  value={images}
                  onChange={onChange}
                  maxNumber={maxNumber}
                  dataURLKey="data_url"
                  acceptType={["png", "jpeg", "jpg", "webp"]}
                >
                  {({
                    imageList,
                    onImageUpload,
                    onImageRemoveAll,
                    onImageUpdate,
                    onImageRemove,
                    isDragging,
                    dragProps,
                  }) => (
                    <div className="upload__image-wrapper">
                      <button
                        style={isDragging ? { color: "red" } : {}}
                        onClick={onImageUpload}
                        {...dragProps}
                        className="btn btn-secondary"
                      >
                        Choose feature image
                      </button>
                      &nbsp;
                      <button
                        className="btn btn-secondary"
                        onClick={onImageRemoveAll}
                      >
                        Remove all images
                      </button>
                      {imageList.map((image, index) => (
                        <div key={index} className="image-item">
                          <img src={image.data_url} alt="" width="100" />
                          <div className="image-item__btn-wrapper">
                            <button
                              className="btn btn-secondary"
                              onClick={() => onImageUpdate(index)}
                            >
                              Update
                            </button>
                            <button
                              className="btn btn-secondary"
                              onClick={() => onImageRemove(index)}
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </ImageUploading>
              </div>
            </div>

            {/* Inputs Grid */}
            <div className="col-3">
              <div className="fv-row mb-7">
                <label className="fs-6 fw-semibold form-label mb-2">
                  <span className="required">Product Name</span>
                </label>
                <input
                  placeholder="Enter a product name"
                  name="title"
                  value={productData?.title || ""}
                  onChange={hendleChangerole}
                  className="form-control bg-transparent"
                />
              </div>
            </div>
            <div className="col-3">
              <div className="fv-row mb-7">
                <label className="fs-6 fw-semibold form-label mb-2">
                  <span className="required">Product Sku</span>
                </label>
                <input
                  placeholder="Enter a sku"
                  name="sku"
                  value={productData?.sku || ""}
                  onChange={hendleChangerole}
                  className="form-control bg-transparent"
                />
              </div>
            </div>
            <div className="col-3">
              <div className="fv-row mb-7">
                <label className="fs-6 fw-semibold form-label mb-2">
                  <span className="required">Price</span>
                </label>
                <input
                  placeholder="Enter a price"
                  name="price"
                  value={productData?.price || ""}
                  onChange={hendleChangerole}
                  className="form-control bg-transparent"
                />
              </div>
            </div>
            <div className="col-3">
              <div className="fv-row mb-7">
                <label className="fs-6 fw-semibold form-label mb-2">
                  <span className="required">After Discount Price</span>
                </label>
                <input
                  placeholder="Enter after discount price"
                  name="afterdiscountprice"
                  value={productData?.afterdiscountprice || ""}
                  onChange={hendleChangerole}
                  className="form-control bg-transparent"
                />
              </div>
            </div>
            <div className="col-3">
              <div className="fv-row mb-7">
                <label className="fs-6 fw-semibold form-label mb-2">
                  <span className="required">GST</span>
                </label>
                <input
                  placeholder="Enter gst"
                  name="gst"
                  value={productData?.gst || ""}
                  onChange={hendleChangerole}
                  className="form-control bg-transparent"
                />
              </div>
            </div>
            <div className="col-3">
              <div className="fv-row mb-7">
                <label className="fs-6 fw-semibold form-label mb-2">
                  <span className="required">BV</span>
                </label>
                <input
                  placeholder="Enter bv"
                  name="bv"
                  value={productData?.bv || ""}
                  onChange={hendleChangerole}
                  className="form-control bg-transparent"
                />
              </div>
            </div>
            <div className="col-3">
              <div className="fv-row mb-7">
                <label className="fs-6 fw-semibold form-label mb-2">
                  <span className="required">Bonus</span>
                </label>
                <input
                  placeholder="Enter bonus"
                  name="bouns"
                  value={productData?.bouns || ""}
                  onChange={hendleChangerole}
                  className="form-control bg-transparent"
                />
              </div>
            </div>
            <div className="col-3">
              <div className="fv-row mb-7">
                <label className="fs-6 fw-semibold form-label mb-2">
                  <span className="required">Delivery Charges</span>
                </label>
                <input
                  placeholder="Enter delivery charges"
                  name="delivery_charges"
                  value={productData?.delivery_charges || ""}
                  onChange={hendleChangerole}
                  className="form-control bg-transparent"
                />
              </div>
            </div>

            {/* Dropdowns */}
            {/* <div className="col-3">
              <div className="fv-row mb-7">
                <label className="fs-6 fw-semibold form-label mb-2">
                  <span className="required">Select Brand</span>
                </label>
                <Select
                  value={selectedOptionbrand}
                  onChange={setSelectedOptionbrand}
                  options={branList}
                />
              </div>
            </div> */}
            <div className="col-3">
              <div className="fv-row mb-7">
                <label className="fs-6 fw-semibold form-label mb-2">
                  <span className="required">Select Main Category</span>
                </label>
                <Select
                  value={selectedOptionPr}
                  onChange={hendletotest}
                  options={maincateList}
                />
              </div>
            </div>
            <div className="col-3">
              <div className="fv-row mb-7">
                <label className="fs-6 fw-semibold form-label mb-2">
                  <span className="required">Select Sub Category</span>
                </label>
                <Select
                  value={selectedOption4}
                  onChange={setSelectedOption4}
                  options={subList4}
                />
              </div>
            </div>
            <div className="col-3">
              <div className="fv-row mb-7">
                <label className="fs-6 fw-semibold form-label mb-2">
                  <span className="required">Select Sub Sub Category</span>
                </label>
                <Select
                  value={selectedOption}
                  onChange={setSelectedOption}
                  options={subList}
                />
              </div>
            </div>

            {/* Description / SEO */}
            <div className="col-12">
              <div className="fv-row mb-7">
                <label className="fs-6 fw-semibold form-label mb-2">
                  <span className="required">Description</span>
                </label>
                {/* <Cktest
                  aboutPage={aboutPage}
                  setaboutPage={setaboutPage}
                  uploadPlugin={uploadPlugin}
                /> */}
                <CKEditor
                  editor={Editor}
                  data={aboutPage}
                  onReady={(editor) => {
                    // console.log('SDfsf')
                    // console.log(editor)
                  }}
                  onChange={(event, editor) => {
                    // console.log(editor)
                    const data = editor.getData();
                    setaboutPage(data);
                  }}
                  config={{
                    extraPlugins: [uploadPlugin],
                  }}
                  onBlur={(event, editor) => {
                    console.log("SDfsf");
                  }}
                  onFocus={(event, editor) => {
                    console.log("SDfsf");
                  }}
                />
              </div>
            </div>
            <div className="col-3">
              <div className="fv-row mb-7">
                <label className="fs-6 fw-semibold form-label mb-2">
                  <span className="required">SEO Title</span>
                </label>
                <input
                  placeholder="Enter seo title"
                  name="seo_title"
                  value={productData?.seo_title || ""}
                  onChange={hendleChangerole}
                  className="form-control bg-transparent"
                />
              </div>
            </div>
            <div className="col-3">
              <div className="fv-row mb-7">
                <label className="fs-6 fw-semibold form-label mb-2">
                  <span className="required">SEO Description</span>
                </label>
                <input
                  placeholder="Enter seo description"
                  name="seo_description"
                  value={productData?.seo_description || ""}
                  onChange={hendleChangerole}
                  className="form-control bg-transparent"
                />
              </div>
            </div>
          </div>

          <h5>Variations</h5>
          {rows.map((row, rowIndex) => (
            <React.Fragment key={rowIndex}>
              {row.productsize.map((sizeProduct, sizeIndex) => (
                <div key={`${rowIndex}-${sizeIndex}`}>
                  {sizeIndex === 0 && (
                    <div className="row">
                      <div className="col-4">
                        <div className="fv-row mb-7">
                          <label className="fs-6 fw-semibold form-label mb-2">
                            <span className="required">Color</span>
                          </label>
                          <input
                            placeholder="Enter color"
                            value={row.color || ""}
                            onChange={(e) =>
                              handleColorChange(
                                rowIndex,
                                sizeIndex,
                                "color",
                                e.target.value,
                              )
                            }
                            className="form-control bg-transparent"
                          />
                        </div>
                      </div>
                      <div className="col-4">
                        <ImageUploading
                          multiple
                          value={row?.images || []}
                          onChange={(e, defaultImages) =>
                            HendleImgFVer(e, defaultImages, rowIndex)
                          }
                          maxNumber={maxNumber}
                          dataURLKey="data_url"
                          acceptType={["png", "jpeg", "jpg", "webp"]}
                        >
                          {({ imageList, onImageUpload }) => (
                            <div>
                              {imageList.map((image, imageIndex) => (
                                <div
                                  key={imageIndex}
                                  className="proadDImgContainer"
                                >
                                  <div className="image-item">
                                    <img
                                      width="100"
                                      src={image.data_url}
                                      alt=""
                                    />
                                  </div>
                                  <button
                                    className="proadDImgBtn btn btn-outline btn-outline-dashed btn-outline-primary btn-active-light-primary"
                                    onClick={() =>
                                      onRemoveImage(rowIndex, imageIndex)
                                    }
                                  >
                                    <i className="fas fa-trash-alt"></i>
                                    <DeleteOutlined />
                                  </button>
                                </div>
                              ))}
                              <button
                                className="btn btn-success mt-5"
                                onClick={onImageUpload}
                              >
                                Add Image
                              </button>
                            </div>
                          )}
                        </ImageUploading>
                      </div>
                    </div>
                  )}

                  <div className="row">
                    <div className="col-2">
                      <div className="fv-row mb-7">
                        <label className="fs-6 fw-semibold form-label mb-2">
                          <span className="required">Size</span>
                        </label>
                        <input
                          placeholder="Enter Size"
                          value={sizeProduct.size || ""}
                          onChange={(e) =>
                            handleSizeChange(
                              rowIndex,
                              sizeIndex,
                              "size",
                              e.target.value,
                            )
                          }
                          className="form-control bg-transparent"
                        />
                      </div>
                    </div>
                    <div className="col-2">
                      <div className="fv-row mb-7">
                        <label className="fs-6 fw-semibold form-label mb-2">
                          <span className="required">Size Type</span>
                        </label>
                        <select
                          className="form-control bg-transparent"
                          value={sizeProduct.sizetype || ""}
                          onChange={(e) =>
                            handleSizeChange(
                              rowIndex,
                              sizeIndex,
                              "sizetype",
                              e.target.value,
                            )
                          }
                        >
                          <option value="">Select Size Type</option>
                          <option value="PICs">PICs</option>
                          <option value="Units">Units</option>
                          <option value="KG">KG</option>
                          <option value="G">G</option>
                          <option value="liter">Liter</option>
                          <option value="ml">ML</option>
                          <option value="Meter">Meter</option>
                          <option value="Inch">Inch</option>
                          <option value="Cm">Cm</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-2">
                      <div className="fv-row mb-7">
                        <label className="fs-6 fw-semibold form-label mb-2">
                          <span className="required">Price</span>
                        </label>
                        <input
                          type="number"
                          placeholder="Enter price"
                          value={sizeProduct.price || ""}
                          onChange={(e) =>
                            handleSizeChange(
                              rowIndex,
                              sizeIndex,
                              "price",
                              e.target.value,
                            )
                          }
                          className="form-control bg-transparent"
                        />
                      </div>
                    </div>
                    <div className="col-2">
                      <div className="fv-row mb-7">
                        <label className="fs-6 fw-semibold form-label mb-2">
                          <span className="required">After Discount Price</span>
                        </label>
                        <input
                          type="number"
                          placeholder="Enter after discount price"
                          value={sizeProduct.afterdiscountprice || ""}
                          onChange={(e) =>
                            handleSizeChange(
                              rowIndex,
                              sizeIndex,
                              "afterdiscountprice",
                              e.target.value,
                            )
                          }
                          className="form-control bg-transparent"
                        />
                      </div>
                    </div>
                    <div className="col-2">
                      <div className="fv-row mb-7">
                        <label className="fs-6 fw-semibold form-label mb-2">
                          <span className="required">Stock</span>
                        </label>
                        <input
                          type="number"
                          placeholder="Enter stock"
                          value={sizeProduct.stock || ""}
                          onChange={(e) =>
                            handleSizeChange(
                              rowIndex,
                              sizeIndex,
                              "stock",
                              e.target.value,
                            )
                          }
                          className="form-control bg-transparent"
                        />
                      </div>
                    </div>
                    <div className="col-2">
                      {row.productsize.length > 1 && (
                        <button
                          className="btn btn-danger"
                          onClick={() => removeSizeProduct(rowIndex, sizeIndex)}
                        >
                          Remove
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}

              <div className="col-4">
                <button
                  className="btn btn-success"
                  onClick={() => addSizeProduct(rowIndex)}
                >
                  Add Size
                </button>
                <button
                  className="btn btn-danger ms-5"
                  onClick={() => removeColorProduct(rowIndex)}
                >
                  Remove Color
                </button>
              </div>
              <hr />
            </React.Fragment>
          ))}

          <div className="row">
            <div className="col-8">
              <button
                className="btn btn-bg-success"
                onClick={() =>
                  setRows((prevRows) => [
                    ...prevRows,
                    {
                      color: "",
                      images: [],
                      productsize: [
                        {
                          size: "",
                          sizetype: "",
                          price: "",
                          afterdiscountprice: "",
                          stock: "",
                        },
                      ],
                    },
                  ])
                }
              >
                Add Row
              </button>
            </div>

            <div className="col-4">
              <button className="btn btn-primary" onClick={hendleTosubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateProduct;
